import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FieldSkeleton = ({ width = "100%" }: { width?: string }) => (
  <div style={{ flex: 1, minWidth: 0 }}>
    <Skeleton height={13} width="45%" style={{ marginBottom: 7 }} borderRadius={4} />
    <Skeleton height={42} width={width} borderRadius={8} />
  </div>
);

const SectionHeader = () => (
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "6px 0 4px" }}>
    <Skeleton height={24} width={200} borderRadius={6} />
    <Skeleton height={32} width={32} borderRadius={6} />
  </div>
);

const Divider = () => (
  <div style={{ borderBottom: "2px dashed #d8e4f0", margin: "4px 0 20px" }} />
);

const FieldRow = ({ count = 3 }: { count?: number }) => (
  <div style={{ display: "flex", gap: 40, marginBottom: 28, flexWrap: "wrap" }}>
    {Array.from({ length: count }).map((_, i) => (
      <FieldSkeleton key={i} />
    ))}
  </div>
);

export default function ModalUpdateCandidateSkeleton() {
  return (
    <SkeletonTheme baseColor="#dce8f5" highlightColor="#f0f6ff" borderRadius={6}>
      {/* Subtítulo centrado */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <Skeleton height={20} width={340} borderRadius={4} />
      </div>

      {/* Sección 1 - Datos personales */}
      <SectionHeader />
      <Divider />
      <FieldRow count={3} />
      <FieldRow count={3} />
      <FieldRow count={2} />

      {/* Sección 2 - Área / Cargo */}
      <SectionHeader />
      <Divider />
      <FieldRow count={3} />
      <FieldRow count={2} />

      {/* Sección 3 - Datos laborales */}
      <SectionHeader />
      <Divider />
      <FieldRow count={3} />

      {/* Botones */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 24, marginTop: 16 }}>
        <Skeleton height={44} width={180} borderRadius={8} />
        <Skeleton height={44} width={180} borderRadius={8} />
      </div>
    </SkeletonTheme>
  );
}
